import { Injectable } from '@angular/core';
import {CanActivate, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class SessionService implements CanActivate  {

  public citizenData
  constructor(public router:Router) { 
    this.citizenData = localStorage.getItem('data');
  }

  canActivate() {
    if (this.citizenData) {
      return true;
    } else {
      // alert("Please Login First");
      this.router.navigate(["home"]);
      return false;
    }
  }
}
 